<template>
  <div>
    <div
      v-if="mode === 'create'">
      <b-row>
        <b-col
          md="6">
          <b-form-group :class="{'error-input' : $v.data_division.name.$error}">
            <label> Name </label>
            <j-input
              v-model="$v.data_division.name.$model"
              :max-length="255"
              placeholder="Name"/>
          </b-form-group>
        </b-col>
        <b-col
          md="6">
          <b-form-group :class="{'error-input' : $v.data_division.code.$error}">
            <label> Code </label>
            <j-input
              v-model="$v.data_division.code.$model"
              :max-length="255"
              placeholder="Code"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          md="6">
          <b-form-group :class="{'error-input' : $v.data_division.head_of_division.$error}">
            <label> Head Of Division </label>
            <j-single-select
              v-model="$v.data_division.head_of_division.$model"
              :is-async="true"
              :load-options="loadOptionsPosition"
              :default-options="false"
              placeholder="Ex: CTO"
              value-format="object"
              label="name"
              search-prompt-text="Type minimum 3 characters to search..."/>
          </b-form-group>
        </b-col>
        <b-col
          md="6">
          <b-form-group :class="{'error-input' : $v.data_division.description.$error}">
            <label> Description </label>
            <j-textarea
              v-model="$v.data_division.description.$model"
              :max-length="300"
              placeholder="Description"/>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div
      v-else>
      <b-row>
        <b-col
          md="6">
          <b-form-group :class="{'error-input' : $v.data_division.id.$error}">
            <label> Division ID </label>
            <j-input
              v-model="$v.data_division.id.$model"
              :max-length="50"
              :disabled="true"
              placeholder="ID"/>
          </b-form-group>
        </b-col>
        <b-col
          md="6">
          <b-form-group :class="{'error-input' : $v.data_division.code.$error}">
            <label> Division Code </label>
            <j-input
              v-model="$v.data_division.code.$model"
              :max-length="255"
              placeholder="Code"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          md="6">
          <b-form-group :class="{'error-input' : $v.data_division.name.$error}">
            <label> Division Name </label>
            <j-input
              v-model="$v.data_division.name.$model"
              :max-length="255"
              placeholder="Name"/>
          </b-form-group>
          <b-form-group :class="{'error-input' : $v.data_division.head_of_division.$error}">
            <label> Head Of Division </label>
            <j-single-select
              v-model="$v.data_division.head_of_division.$model"
              :is-async="true"
              :load-options="loadOptionsPosition"
              :default-options="false"
              placeholder="Ex: CTO"
              value-format="object"
              label="name"
              search-prompt-text="Type minimum 3 characters to search..."/>
          </b-form-group>
        </b-col>
        <b-col
          md="6">
          <b-form-group :class="{'error-input' : $v.data_division.description.$error}">
            <label> Description </label>
            <j-textarea
              v-model="$v.data_division.description.$model"
              :max-length="300"
              :rows="5"
              placeholder="Description"/>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import jDivisionFlow from '@/views/division/jDivisionFlow';

export default {
  validations: {
    data_division: {
      id: {

      },
      name: {
        required,
      },
      code: {
        required,
      },
      head_of_division: {

      },
      description: {

      },
    },
  },
  components: {
    jDivisionFlow,
  },
  data() {
    return {
      cimbFeature: false,
      data_division: {
        id: 0,
        name: '',
        code: '',
        head_of_division: null,
        description: '',
        flow_id: 0,
      },
      mode: 'create',
    };
  },
  computed: {
    ...mapState('jStoreDivisionFlow', ['division_detail']),
  },
  watch: {
    division_detail(newVal) {
      const divisionForm = {
        id: newVal.id,
        name: newVal.name,
        code: newVal.code,
        description: newVal.description,
        flow_id: newVal.flow_id ? newVal.flow_id : 0,
      };
      this.data_division = divisionForm;
      if (typeof newVal.head_organigram.id !== 'undefined') {
        this.data_division.head_of_division = {
          id: newVal.head_organigram.id,
          name: newVal.head_organigram.name,
          label: newVal.head_organigram.name,
        };
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.mode = 'update';
      this.modeUpdate();
    }
  },
  methods: {
    ...mapActions('jStoreDivisionFlow', ['getDivisionDetail']),

    modeUpdate() {
      const divisionId = {
        id: Number(this.$route.params.id),
      };

      this.getDivisionDetail(divisionId);
    },

    loadOptionsPosition({ action, searchQuery, callback }) {
      let queryType;
      switch (this.filter ? this.filter : '') {
        case 'email':
          queryType = 'email';
          break;
        case 'user_name':
          queryType = 'name';
          break;
        default:
          queryType = 'position';
          break;
      }
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
              query_type: queryType,
            },
          };
          this.$store.dispatch('jStoreFlows/getListPosition', { reqData, callback, label: (this.filter ? this.filter : 'name') });
        } else {
          callback(null, false);
        }
      }
    },

    save() {
      this.$v.data_division.$touch();
      if (!this.$v.data_division.$error) {
        this.$emit('data', this.data_division);
      } else {
        this.$emit('data', null);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/division/jDivisionForm.vue